<template>
  <div>
    <div class="tab">
      <!-- 空一个江苏城歌的位置 -->
      <div class="name">
        <!-- logo -->
        <div class="logo"></div>
        <!-- name -->
        <div class="real-name">
          <img src="../assets/img/home/chengge.png" alt="" />
        </div>
      </div>
      <!-- 标题栏 -->
      <div class="title">
        <!-- for循环tabNameList -->
        <div
          class="title-item"
          v-for="(item, index) in tabNameList"
          :key="index"
        >
          <div class="title-name" @click="goDetail(item.path)">
            {{ item.name }}
          </div>
          <!-- 是否右边斜杠 -->
          <div v-if="item.slash" class="slash">/</div>
        </div>
      </div>
      <!-- 右侧服务热线 -->
      <div class="tel">
        <div class="phone">
          <img src="../assets/img/home/phone.png" alt="" />
        </div>
        <div class="tel-num">
          <div style="letter-spacing: 14px;margin-left:5px;">招商合作</div>
          <div>
            {{ mobile }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 标题栏
      tabNameList: [
        {
          name: '首页',
          path: '/',
          slash: true
        },
        {
          name: '智慧终端',
          path: '/device',
          slash: true
        },
        {
          name: 'AI识别',
          path: '/AI',
          slash: true
        },
        {
          name: '智慧新零售',
          path: '/retail',
          slash: true
        },
        {
          name: '关于我们',
          path: '/about',
          slash: false
        }
      ],
      mobile: this.GLOBAL.mobile,
      // 当前页面path
      pathname: ''
    }
  },
  created() {
    this.pathname = window.location.pathname
  },
  methods: {
    // 跳转到其他页面
    goDetail(path) {
      // 解决点击当前页面报错问题
      if (path !== this.pathname) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tab {
  display: flex;
  padding: 40px 50px 0 50px;
  margin: 0 auto;
  width: 1300px;
  .name {
    width: 255px;
    .real-name {
      img {
        margin-top: -10px;
      }
    }
  }
  .title {
    width: 960px;
    display: flex;
    height: 40px;
    line-height: 40px;
    position: relative;
    .title-item {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      width: 160px;
      .title-name {
        width: 130px;
        text-align: center;
        margin-left: 20px;
      }
      .title-name:hover {
        font-size: 26px;
      }

      .slash {
        color: #d5d5d5;
      }
    }
  }
  .tel {
    width: 300px;
    display: flex;
    .phone {
      line-height: 60px;
      img {
        width: 37px;
        height: 37px;
      }
    }
    .tel-num {
      width: 200px;
      margin: -10px 0 0 10px;
    }
  }
}
.secondTitle {
  position: absolute;
  top: 50px;
  left: 170px;
}
.transition-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  width: 150px;
  height: 60px;
  border-radius: 4px;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
}
</style>
